import subDomain, { defaultMunicipality } from "../config/subDomain"
import { getMunicipalityFromUrl }         from "./core-helpers"

export const getMun = getMunicipalityFromUrl

export const getMunData = () => subDomain[getMun()] || subDomain[defaultMunicipality]



// WEBPACK FOOTER //
// ./src/utils/getMunicipality.js